import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  nextSteps: () => i18n.t(i18nKeys.common__nextSteps),
  explanationPickUp: () => i18n.t(i18nKeys.preScreenDetail__explanationPickUp),
  explanationOrientation: () =>
    i18n.t(i18nKeys.preScreenDetail__explanationOrientation),
  orientationInfo: () => i18n.t(i18nKeys.preScreenDetail__orientationInfo),
  questionsOne: () => i18n.t(i18nKeys.preScreenDetail__questionsOne),
  questionsTwo: () => i18n.t(i18nKeys.preScreenDetail__questionsTwo),
  aboutDoorDash: () => i18n.t(i18nKeys.preScreenDetail__aboutDoorDash),
  dasherFaqs: () => i18n.t(i18nKeys.preScreenDetail__dasherFaqs),
  stillNeedToSubmit: () => i18n.t(i18nKeys.preScreenDetail__stillNeedToSubmit),
}
